module.exports = __webpack_public_path__ + "a1f9f03a39546c2c4414ac778fc3538a.svg";